import { render, staticRenderFns } from "./ButtonsCardList.vue?vue&type=template&id=36adb74e"
import script from "./ButtonsCardList.vue?vue&type=script&lang=js"
export * from "./ButtonsCardList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports